import * as React from 'react';
import styles from './TradeInSubCategories.scss';
import TabMenu, { ITabMenuItem } from '~/components/TabMenu/TabMenu';
import equal from 'fast-deep-equal/react';
import History from '~/utils/history';
import { getUrl, urlsMap } from '~/utils/menu';
import { RootState, useAppSelector } from '~/Store';

interface ITradeInSubCategories {
    category: ICategory;
}

const stateSelector = (state: RootState) => {
    return {
        categories: state.app.categories,
        currentPage: state.app.currentPage,
    };
};

const TradeInSubCategories = ({ category }: ITradeInSubCategories) => {
    const { categories, currentPage } = useAppSelector(stateSelector, equal);
    const subCategories = React.useMemo<string[]>(() => {
        if (!category) {
            return [];
        }
        const names = !!category.subCategories.length ? [...category.subCategories] : [...(category.parentCategoryData?.subCategories || [])];
        return names.splice(1, names.length);
    }, [category]);

    if (!subCategories.length || subCategories.length === 1) {
        return null;
    }

    const tabs: ITabMenuItem[] = subCategories.map((categoryName: string) => {
        let isActive = currentPage?.name === categoryName;

        if (categories[currentPage?.name].subCategories?.length) {
            isActive = categoryName === subCategories[0];
        }

        return {
            title: categories[categoryName].title,
            isActive,
            onClick: () => {
                History.navigate(
                    getUrl(urlsMap.subCategory, {
                        categoryName: categories[categoryName].parentCategoryData?.name,
                        subCategoryName: categoryName,
                    }),
                );
            },
        };
    });

    return (
        <div className={styles.wrapper}>
            <TabMenu tabs={tabs} />
        </div>
    );
};

export default TradeInSubCategories;
